<template>
  <div id="L2" class="sub">
    <div class="wrapper">
      <kg-header :headerType=0 />
      <div id="content">
        <div class="inner_static">
          <div id="register">
            <h1 class="tit1">パスワードの再設定</h1>
            <p class="lead_upper">
              パスワードの再設定を行います。<br>
              他人に推測されやすいものは避けてください。
            </p>
            <div v-if="errorMessage.text"><label class="error_text">{{ errorMessage.text }}</label></div>
            <div v-if="validateErrorMessages">
              <div v-for="(msg,index) in validateErrorMessages" :key="index"><label class="error_text">{{msg}}</label></div>
            </div>
            <div v-if="errors.email"><label class="error_text">{{errors.email}}</label></div>
            <div v-if="errors.password"><label class="error_text">{{errors.password}}</label></div>
            <ul class="lst_register">
              <li>
                <div class="item">
                  <label for="email">【メールアドレス】<strong class="req">※必須</strong></label>
                </div>
                <div class="cnt">
                  <div class="ins_wrap">
                    <input type="text" id="email" name="email" class="int" v-model="userForm.userEmail">
                  </div>
                </div>
              </li>
              <li>
                <div class="item">
                  <label for="password">【パスワード】<strong class="req">※必須</strong></label>
                </div>
                <div class="cnt">
                  <div class="ins_wrap">
                    <input type="text" id="password" name="password" v-model="userForm.password" class="int">
                  </div>
                  <p class="att">※メールアドレスと異なる、英数字8〜12文字でご入力ください。</p>
                </div>
              </li>
            </ul>
            <div class="fixed_btn_area">
              <div class="inner_static">
                <a class="btn1" @click="confirm()">確認する</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <kg-loading-modal ref="loadingModalRef" />
  </div>
</template>

<script>
import axios from 'axios'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import {KG_URL, KG_STORAGE_KEY} from '../../constants/App'
import * as Check from '../../utils/Check'

// kagull Module
import Header from '../components/common/HomeIconHeader'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  components: {
    'kg-header': Header,
    'kg-loading-modal': LoadingModal
  },
  data () {
    return {
      userForm: {
        password: '',
        confirmPassword: '',
        userEmail: '',
        token: ''
      },
      errors: {},
      submitDisable: false,
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      validateErrorMessages: {},
      label: {
        password: '新しいパスワード',
        confirmPassword: '新しいパスワード（確認用）'
      }
    }
  },
  methods: {
    confirm: function () {
      if (this.submitDisable) return
      this.submitDisable = true
      this.$refs.loadingModalRef.showModal(true)
      this.errorMessage.text = ''
      this.validateErrorMessages = {}
      this.errors = {}
      this.validatedReqire()
      if (Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        this.submitDisable = false
        return
      }
      // 入力フォームをローカルストレージにセットして確認画面に進む
      this.fetchData()
      this.$router.push('/kagull/user/reset/updateconfirm')
      this.$refs.loadingModalRef.showModal(false)
      this.submitDisable = false
    },
    fetchData: function () {
      App.setLocalStorage(KG_STORAGE_KEY.PASSWORD_DATA, this.userForm)
    },
    validatedReqire: function () {
      if (!Check.isMail(this.userForm.userEmail)) {
        this.errors['email'] = 'メールアドレスの形式ではありません。'
      }
      if (!Check.isPassword(this.userForm.password)) {
        this.errors['password'] = this.label.password + 'は半角英小文字、数字を含む8文字以上の20字以下のパスワードを設定してください。'
      }
    // TODO: パスワード確認用入力欄自体が無い
    //   if (this.userForm.password !== this.userForm.confirmPassword) {
    //     this.errors['confirmPassword'] = this.label.confirmPassword + 'が一致しません。'
    //   }
    },
    // パスワードリセット時に送られるURLを、踏んで来る際にトークンチェック
    tokenCheck: function (lForm) {
      let payload = {}
      if (lForm) {
        // 次の確認画面から戻ってきた場合はクエリではなく引数の値を用いる
        payload = {
          userEmail: lForm.userEmail,
          token: lForm.token
        }
      } else {
        payload = {
          userEmail: this.$route.query.email,
          token: this.$route.query.token
        }
      }
      axios.post(KG_URL.USER + '/reset/check-reset-password-token', payload
      ).then(response => {
      }).catch(error => {
        this.isRegistrable = false
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        App.setLocalStorage(KG_STORAGE_KEY.TOKEN_ERROR_FLAG, 1)
        this.$router.push('/kagull/error')
      })
    }
  },
  created () {
    let lForm = App.getLocalStorage(KG_STORAGE_KEY.PASSWORD_DATA)

    if (Object.keys(lForm).length <= 0) {
      this.tokenCheck()
    } else {
      // 次の確認画面から戻って来た場合
      this.tokenCheck(lForm)
    }

    if (Object.keys(lForm).length <= 0) {
      // GET 初回遷移
      this.userForm.userEmail = this.$route.query.email
      this.userForm.token = this.$route.query.token
      this.fetchData()
    } else {
      this.userForm = lForm
    }
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/PasswordResetUpdate.vue